import { NavBarNames } from "./NavBarNameList";

// home breadcrumb
export const homeBreads = () => {
  return [{ name: 'Home', link: '/' }];
};

//campaign breadcrumb
export const campaignListBreads = () => {
  const homeBreadList = homeBreads();
  homeBreadList.push({ name: 'Campaigns', link: '/campaigns' });
  return homeBreadList;
};

export const createCampaignBreads = (bread) => {
  const camapignListBreadList = campaignListBreads();
  camapignListBreadList.push({
    name: `${bread ? bread : 'Create Campaign'}`,
    link: '/campaigns/create',
  });
  return camapignListBreadList;
};

export const editCampaignBreads = () => {
  const camapignListBreadList = campaignListBreads();
  camapignListBreadList.push({
    name: 'Edit Campaign',
  });
  return camapignListBreadList;
};

// stamp campaign
export const stampCampaignListBreads = () => {
  const homeBreadList = homeBreads();
  homeBreadList.push({ name: NavBarNames.stampCampaigns, link: '/stamp_campaigns' });
  return homeBreadList;
};

export const createStampCampaignBreads = (bread) => {
  const camapignListBreadList = stampCampaignListBreads();
  camapignListBreadList.push({
    name: `${bread ? bread : 'Create Stamp campaign'}`,
    link: '/stamp_campaigns/create',
  });
  return camapignListBreadList;
};

export const editStampCampaignBreads = () => {
  const camapignListBreadList = stampCampaignListBreads();
  camapignListBreadList.push({
    name: 'Edit Campaign',
  });
  return camapignListBreadList;
};

// coupon breadcrumb

export const couponSetBreads = () => {
  const homeBreadList = homeBreads();
  homeBreadList.push({
    name: 'Coupon Sets',
    link: '/coupons',
  });
  return homeBreadList;
};

export const createCouponBreads = (id) => {
  const couponSetBreadList = couponSetBreads();
  couponSetBreadList.push({
    name: `${id ? 'Edit': 'Create'} Coupon Set`,
    link: '/coupons/create',
  });
  return couponSetBreadList;
};

export const couponSetDetailBreads = (couponSetName, isBack = false) => {
  const couponSetListBreadList = couponSetBreads();
  couponSetListBreadList.push({
    name: couponSetName,
    link: '/coupons/couponSet',
    isBack: isBack,
  });
  return couponSetListBreadList;
};

export const singleCouponBreads = (couponSetName, singleCouponSerialNum) => {
  const couponSetDetailBreadList = couponSetDetailBreads(couponSetName, true);
  couponSetDetailBreadList.push({
    name: singleCouponSerialNum,
    link: '/coupons/couponSet/singleCoupon',
  });
  return couponSetDetailBreadList;
};
